export const initialUiState = {
  loading: false,
  drawer_open: false,
  view: {
    facility: null,
    cup: null,
    district: null,
  },
  edit: {
    cup: null,
    facility: null,
  },
}

export const uiReducer = (state, action) => {
  switch (action.type) {
    case "START_LOADING": {
      return { ...state, loading: true }
    }
    case "STOP_LOADING": {
      return { ...state, loading: false }
    }
    case "OPEN_DRAWER": {
      return { ...state, drawer_open: true }
    }
    case "CLOSE_DRAWER": {
      return { ...state, drawer_open: false }
    }
    case "SET_VIEW_CUP": {
      const { id } = action.payload
      return { ...state, view: { ...state.view, cup: id } }
    }
    case "SET_VIEW_FACILITY": {
      const { id } = action.payload
      return { ...state, view: { ...state.view, facility: id } }
    }
    case "SET_VIEW_DISTRICT": {
      const { id } = action.payload
      return { ...state, view: { ...state.view, district: id } }
    }
    case "SET_EDIT_CUP": {
      const {
        payload: { feature },
      } = action
      return { ...state, edit: { ...state.edit, cup: feature } }
    }
    case "SET_EDIT_FACILITY": {
      const {
        payload: { feature },
      } = action
      return { ...state, edit: { ...state.edit, facility: feature } }
    }
    default:
      return state
  }
}
